import { render, staticRenderFns } from "./Judge.vue?vue&type=template&id=ca4452ec&scoped=true"
import script from "./Judge.vue?vue&type=script&lang=js"
export * from "./Judge.vue?vue&type=script&lang=js"
import style0 from "./Judge.vue?vue&type=style&index=0&id=ca4452ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4452ec",
  null
  
)

export default component.exports